/**
* @ngdoc directive
* @name Secondary Actions
*
* @description
  A list of actions at the bottom of the page
*
* @scope
* @param {Any} model - will be provided in action callback
* @param {Array} actions - with properties
*   callback - on action click
*   label - action label
*   class - class for icon visible before action label
*
* @example
  <secondary-actions actions="[{ callback: alert, class: 'glyphicon glyphicon-link', label: 'Alert' }, { callback: alert, class: 'glyphicon glyphicon-refresh', label: 'Alert Again' }]"></secondary-actions>
*/

(function () {
  'use strict';

  SecondaryActions.$inject = ["PATH"];
  controller.$inject = ["$scope", "$modal", "PATH", "$timeout"];
  app.directive('secondaryActions', SecondaryActions);

  function SecondaryActions(PATH) {
    /**
     * SecondaryActions - directive show modal with actions on click
     *
     * @param  {Array} actions - actions array to display in popup
     */
    return {
      replace: true,
      scope: {
        model: '=?',
        actions: '=?'
      },
      restrict: 'E',
      templateUrl: PATH.components + 'secondaryActions/template.html',
      controller: controller
    };
  }

  function controller($scope, $modal, PATH, $timeout) {
    /**
     * secondary actions modal
     */
    $scope.secondaryActionsModal = $modal({
      show: false,
      contentTemplate: PATH.components + 'secondaryActions/template.modal.html',
      scope: $scope,
      prefixClass: 'secondary-actions-modal'
    });

    /**
     * show modal
     */
    $scope.showModal = function () {
      $scope.secondaryActionsModal.$promise.then(function () {
        $scope.secondaryActionsModal.show();
      });
    };

    /**
     * Close secondary actions modal
     */
    $scope.closeModal = function () {
      $scope.secondaryActionsModal.hide();
    };

    $scope.onActionClick = function (action) {
      $timeout(function () {
        $scope.closeModal();
        $scope.model && action.callback($scope.model);
      }, 600);
    };

    $scope.isActionShow = function (action) {
      return action.isShow ? action.isShow($scope.model) : true;
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/secondaryActions/directive.js